import { DateYMDString } from "./date-time.models";

export enum BookingPrepareConflictErrorType {
  fieldsExceedHeaders = "fieldsExceedHeaders",
  passengerCodeIsNotValid = "passengerCodeIsNotValid",
  passengerCodeNotProvided = "passengerCodeNotProvided",
  passengerNotFoundByCode = "passengerNotFoundByCode",
  dateIsNotValid = "dateIsNotValid",
  dateNotProvided = "dateNotProvided",
  arrivalTimeIsNotValid = "arrivalTimeIsNotValid",
  departureTimeIsNotValid = "departureTimeIsNotValid",
}

export interface IBookingPrepareConflict {
  index: number;
  passengerCode?: string;
  date?: DateYMDString;
  errorType: BookingPrepareConflictErrorType;
}
